var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.isExpired
        ? _c(
            "div",
            [
              _c("passcode-reader", {
                ref: "passcodeReader",
                attrs: {
                  icon: _vm.icon,
                  title: _vm.title,
                  description: _vm.description,
                  "confirmation-data": _vm.confirmationData,
                  "is-marked-as-error": _vm.isInvalidCodeBackendResponse,
                },
                on: {
                  errorNotification: _vm.sendErrorNotification,
                  validPasscode: _vm.setValidPasscode,
                },
                nativeOn: {
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.processEnter.apply(null, arguments)
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isExpired
        ? _c(
            "div",
            [
              _c("warning-step", {
                attrs: {
                  title: "Account Verification expired",
                  description:
                    "The user a passcode has expired due to multiple failed attempts.",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.isProcessing
        ? _c(
            "div",
            { staticClass: "account-verification__step__buttons-container" },
            [
              _vm.verificationMethodType ===
              _vm.VERIFICATION_METHODS_MAP.RING_APP_CONTROL_CENTER
                ? _c(
                    "div",
                    [
                      _c(
                        "el-button",
                        {
                          staticClass:
                            "account-verification__step__button account-verification__step__button-white",
                          attrs: {
                            plain: "",
                            type: "primary",
                            "data-test-id": "backButton",
                          },
                          on: { click: _vm.notifyBack },
                        },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(_vm.backButtonText) +
                              "\n      "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          staticClass: "account-verification__step__button",
                          attrs: {
                            type: "primary",
                            "data-test-id": "verify_passcode_button",
                            disabled: !_vm.isValidPasscode,
                          },
                          on: { click: _vm.verifyCode },
                        },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(_vm.processButtonText) +
                              "\n      "
                          ),
                        ]
                      ),
                    ],
                    1
                  )
                : _c(
                    "div",
                    [
                      _vm.isSingleVerificationChannel && _vm.showResendButton
                        ? _c(
                            "el-button",
                            {
                              staticClass:
                                "account-verification__step__button account-verification__step__button-white",
                              attrs: { plain: "", type: "primary" },
                              on: { click: _vm.notifyBack },
                            },
                            [
                              _vm._v(
                                "\n        " +
                                  _vm._s(_vm.resendButtonText) +
                                  "\n      "
                              ),
                            ]
                          )
                        : _vm.showResendButton
                        ? _c(
                            "el-button",
                            {
                              staticClass:
                                "account-verification__step__button account-verification__step__button-white",
                              attrs: {
                                plain: "",
                                type: "primary",
                                "data-test-id": "try_different_method_button",
                              },
                              on: { click: _vm.tryDifferentMethod },
                            },
                            [
                              _vm._v(
                                "\n        " +
                                  _vm._s(_vm.tryDifferentMethodButtonText) +
                                  "\n      "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          staticClass: "account-verification__step__button",
                          attrs: {
                            type: "primary",
                            "data-test-id": "verify_passcode_button",
                            disabled: !_vm.isValidPasscode || _vm.isExpired,
                          },
                          on: { click: _vm.verifyCode },
                        },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(_vm.processButtonText) +
                              "\n      "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
            ]
          )
        : _vm.isProcessing
        ? _c("processing-info", {
            staticClass: "email-confirmation__processing-info",
            style: _vm.additionalProcessingInfoStyles,
            attrs: {
              message: _vm.processingMessage,
              "info-type": _vm.processingInfoType,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }